import { Injectable } from "@angular/core";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { UtilService } from "../utils/util.service";
import { LoginService } from "../auth/login/login.service";
import { AccountService } from "../account/account.service";
import { Observable, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import firebase from "firebase/compat/app";

export interface UploadProgressCallback {
  (progress: number): void;
}

@Injectable({
  providedIn: "root"
})
export class AuthorityVerificationFileService {
  private fireStorage;

  constructor(
    private aFireStorage: AngularFireStorage,
    private utilService: UtilService,
    private loginService: LoginService,
    private accountService: AccountService
  ) {
    this.fireStorage = this.aFireStorage.storage.app.storage("tboss-authact");
  }

  generateFilePath(profileId: string, accountUuid: string, fileName: string): string {
    const fileExt = fileName.split(".").pop() || "";
    return `taskezy/authoritytoact/${profileId}/${accountUuid}/authorityUpload-${this.utilService.randomString(5)}.${fileExt}`;
  }

  createFileMetadata(file: File, account: any, profile: any): any {
    const accountDetails = account?.detail;
    return {
      originalName: file.name,
      env: this.utilService.getEnv(),
      accountUUID: account.uuid,
      accountName: accountDetails?.name,
      accounttradingname: account?.detail?.tradingname,
      accountPhone: accountDetails?.phone,
      accountAddress: accountDetails?.primary_address,
      accountAbn: accountDetails?.abn,
      userFullName: profile.fullName,
      userUUID: profile.id,
      userEmail: profile.email,
    };
  }

  uploadAndRequestVerification(
    file: File,
    account: any,
    profile: any,
    progressCallback?: UploadProgressCallback
  ): Observable<any> {
    return this.loginService.loginToFirebase().pipe(
      switchMap(() => {
        const filepath = this.generateFilePath(profile.id, account.uuid, file.name);
        const metadata = this.createFileMetadata(file, account, profile);
        const task = this.fireStorage.ref(filepath).put(file, {
          contentType: file.type,
          customMetadata: metadata,
        });

        task.on(
          firebase.storage.TaskEvent.STATE_CHANGED,
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (progressCallback) {
              progressCallback(progress);
            }
          }
        );

        return from(task.then((snapshot) => snapshot));
      }),
      switchMap(() => {
        return this.accountService.requestAccountVerification(account.uuid);
      })
    );
  }
}
